/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_TeamInputs */

const th_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบทีมนี้`)
};

const en_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That team does not exist.`)
};

const ja_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このチームは存在しません。`)
};

const zh_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该球队不存在。`)
};

const es_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese equipo no existe.`)
};

const pt_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse time não existe.`)
};

const id_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim itu tidak ada.`)
};

const fr_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette équipe n’existe pas.`)
};

const tl_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ang team na iyon.`)
};

const vi_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có đội đó.`)
};

const ko_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그런 팀은 없습니다.`)
};

const de_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Team gibt es nicht.`)
};

const ru_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такой команды нет.`)
};

const tr_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böyle bir takım yok.`)
};

const it_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quella squadra non esiste.`)
};

const pl_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taka drużyna nie istnieje.`)
};

const uk_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такої команди немає.`)
};

const hi_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह टीम मौजूद नहीं है।`)
};

const ar_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذلك الفريق غير موجود.`)
};

const ms_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan itu tidak wujud.`)
};

const bn_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই দল নেই।`)
};

const zh_tw2_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該球隊不存在。`)
};

const zh_hk2_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該球隊不存在。`)
};

const ur_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ ٹیم موجود نہیں۔`)
};

const fa_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چنین تیمی وجود ندارد.`)
};

const sw_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu hiyo haipo.`)
};

const nl_not_found_team = /** @type {(inputs: Not_Found_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat team bestaat niet.`)
};

/**
* | output |
* | --- |
* | "That team does not exist." |
*
* @param {Not_Found_TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const not_found_team = /** @type {((inputs?: Not_Found_TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_not_found_team(inputs)
	if (locale === "ja") return ja_not_found_team(inputs)
	if (locale === "zh") return zh_not_found_team(inputs)
	if (locale === "es") return es_not_found_team(inputs)
	if (locale === "pt") return pt_not_found_team(inputs)
	if (locale === "id") return id_not_found_team(inputs)
	if (locale === "fr") return fr_not_found_team(inputs)
	if (locale === "tl") return tl_not_found_team(inputs)
	if (locale === "vi") return vi_not_found_team(inputs)
	if (locale === "ko") return ko_not_found_team(inputs)
	if (locale === "de") return de_not_found_team(inputs)
	if (locale === "ru") return ru_not_found_team(inputs)
	if (locale === "tr") return tr_not_found_team(inputs)
	if (locale === "it") return it_not_found_team(inputs)
	if (locale === "pl") return pl_not_found_team(inputs)
	if (locale === "uk") return uk_not_found_team(inputs)
	if (locale === "hi") return hi_not_found_team(inputs)
	if (locale === "ar") return ar_not_found_team(inputs)
	if (locale === "ms") return ms_not_found_team(inputs)
	if (locale === "bn") return bn_not_found_team(inputs)
	if (locale === "zh-TW") return zh_tw2_not_found_team(inputs)
	if (locale === "zh-HK") return zh_hk2_not_found_team(inputs)
	if (locale === "ur") return ur_not_found_team(inputs)
	if (locale === "fa") return fa_not_found_team(inputs)
	if (locale === "sw") return sw_not_found_team(inputs)
	if (locale === "nl") return nl_not_found_team(inputs)
	return en_not_found_team(inputs)
});